<template>
  <div>
    <div v-if="timeout" class="container text-start">
      <div id="thanks" class="mb-5">
        <div class="
          bg-white
          rounded
          shadow-lg
          px-md-5 px-4
          py-4
          pb-5
          my-5
          text-center
        ">
          <h1 class="text-tpbs-1 fw-bold">ปิดการโหวตแล้ว</h1>
           การสำรวจนี้เป็นกระบวนการรับฟังความคิดเห็น <br>เพื่อเป็นข้อมูลประกอบการรายงานข่าว
          <br>ซึ่งขณะนี้ได้ปิดการโหวตแล้ว
          <h3 class="mt-4">
            สามารถติดตามผล Thai PBS Poll และผลการนับคะแนนเลือกตั้งผู้ว่าฯ กทม. และ
            ส.ก.ได้ทางไทยพีบีเอส ช่องหมายเลข 3 และ
            <strong><a target="_blank"
                href="https://event.thaipbs.or.th/BKKElection65/">www.thaipbs.or.th/BKKElection65</a></strong>
          </h3>
          <hr />
          <h3 class="mt-4">หรือผ่านช่องทางโซเชียลมีเดีย</h3>
          <div>
            <a target="_blank" alt="Facebook" href="https://www.facebook.com/ThaiPBS"
              class="btn text-theme-1 fs-3 px-2">
              <i class="fa-brands fa-facebook"></i>
            </a>
            <a target="_blank" alt="Twitter" href="https://twitter.com/ThaiPBS" class="btn text-theme-1 fs-3 px-2">
              <i class="fa-brands fa-twitter"></i>
            </a>
            <a target="_blank" alt="Youtube" href="https://www.youtube.com/user/ThaiPBS"
              class="btn text-theme-1 fs-3 px-2">
              <i class="fa-brands fa-youtube"></i>
            </a>
            <a target="_blank" alt="LINE" href="http://www.thaipbs.or.th/AddLINE" class="btn text-theme-1 fs-3 px-2">
              <i class="fa-brands fa-line"></i>
            </a>
            <a target="_blank" alt="Instagram" href="https://www.instagram.com/ThaiPBS/"
              class="btn text-theme-1 fs-3 px-2">
              <i class="fa-brands fa-instagram"></i>
            </a>
            <a target="_blank" alt="TikTok" href="https://www.tiktok.com/@ThaiPBS" class="btn text-theme-1 fs-3 px-2">
              <i class="fa-brands fa-tiktok"></i>
            </a>
            <a target="_blank" alt="Blockdit" href="https://www.blockdit.com/ThaiPBS"
              class="btn text-theme-1 fs-3 px-2">
              <img src="imgs/blockdit.svg" style="vertical-align: baseline; width: 24px; height: 24px" />
            </a>
          </div>
        </div>
        <br /><br /><br /><br /><br /><br /><br /><br />
      </div>
    </div>
    <div v-if="!timeout" class="container text-start">
      <div class="bg-white rounded shadow-lg py-3 mb-4 text-center text-muted" style="line-height: 28px;">
        *การสำรวจนี้เป็นกระบวนการรับฟังความคิดเห็น <br>เพื่อเป็นข้อมูลประกอบการรายงานข่าว
        <br>ซึ่งจะเปิดเผยหลังการเลือกตั้งเสร็จสิ้นลง
      </div>
      <div v-if="!success && !vote && user">
        <div class="bg-white rounded shadow-lg px-md-5 px-4 py-4 mb-4">
          <table>
            <tbody>
              <tr>
                <td class="vertical-top">
                  <div class="list-number me-2">1</div>
                </td>
                <td>
                  <h2 id="q1">
                    <span class="fw-bold">ระบุเพศของคุณ</span>
                    <span v-if="warnings[0]" class="text-danger">
                      ( *กรุณาระบุตัวเลือก )</span>
                  </h2>

                  <div class="">
                    <div class="form-check fs-3">
                      <input class="form-check-input" type="checkbox" value="" id="checkboxGenderMale"
                        @change="selectGender('male')" :checked="gender == 'male'" :disabled="loading" />
                      <label class="form-check-label" for="checkboxGenderMale">
                        ชาย
                      </label>
                    </div>
                    <div class="form-check fs-3">
                      <input class="form-check-input" type="checkbox" value="" id="checkboxGenderFemale"
                        @change="selectGender('female')" :checked="gender == 'female'" :disabled="loading" />
                      <label class="form-check-label" for="checkboxGenderFemale">
                        หญิง
                      </label>
                    </div>
                    <div class="form-check fs-3">
                      <input class="form-check-input" type="checkbox" value="" id="checkboxGenderOther"
                        @change="selectGender('other')" :checked="gender == 'other'" :disabled="loading" />
                      <label class="form-check-label" for="checkboxGenderOther">
                        อื่นๆ
                      </label>
                    </div>
                    <div class="form-check fs-3">
                      <input class="form-check-input" type="checkbox" value="" id="checkboxGenderUnidentified"
                        @change="selectGender('unidentified')" :checked="gender == 'unidentified'"
                        :disabled="loading" />
                      <label class="form-check-label" for="checkboxGenderUnidentified">
                        ไม่ระบุ
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="bg-white rounded shadow-lg px-md-5 px-4 py-4 mb-4">
          <table>
            <tbody>
              <tr>
                <td class="vertical-top">
                  <div class="list-number me-2">2</div>
                </td>
                <td>
                  <h2 id="q2">
                    <span class="fw-bold">อายุของคุณ</span>
                    <span v-if="warnings[1]" class="text-danger">
                      ( *กรุณากรอกข้อมูลเป็นตัวเลข )</span>
                  </h2>
                  <div class="mb-2">
                    <input type="number" class="form-control fs-4" id="exampleFormControlInput1"
                      placeholder="พิมพ์อายุของคุณ..." v-model="age" :disabled="loading" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="bg-white rounded shadow-lg px-md-5 px-4 py-4 mb-4">
          <table>
            <tbody>
              <tr>
                <td class="vertical-top">
                  <div class="list-number me-2">3</div>
                </td>
                <td>
                  <h2 id="q3">
                    <span class="fw-bold">คุณมีสิทธิเลือกตั้งในเขตใด</span>
                    <span v-if="warnings[2]" class="text-danger">
                      ( *กรุณาเลือก )</span>
                  </h2>
                  <div class="mb-2">
                    <select class="form-select fs-4" aria-label="Default select example" v-model="selectedDistrict"
                      :disabled="loading">
                      <option :value="null">เลือกเขต...</option>
                      <option v-for="item in districts" :key="item.label" :value="item.value">
                        {{ item.label }}
                      </option>
                    </select>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="bg-white rounded shadow-lg px-md-5 px-4 py-4 mb-4">
          <table class="w-100 pe-1">
            <tbody>
              <tr>
                <td class="vertical-top">
                  <div class="list-number me-2">4</div>
                </td>
                <td>
                  <h2 id="q4">
                    <span class="fw-bold">ผู้สมัครผู้ว่าฯ กทม. ที่คุณจะเลือกคือ...?</span>
                    (เรียงตามหมายเลข)
                    <span v-if="warnings[3]" class="text-danger">
                      ( *กรุณาเลือก )</span>
                  </h2>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="mb-2">
            <div v-if="candidates == null" class="spinner-grow text-theme-1" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <ul class="list-group list-group-flush">
              <a href="#q5" v-for="(item, index) in candidates" v-on:click="switchCandidate(index)" :key="index"
                class="list-group-item list-group-item-action candidate" :class="toggleCandidate(index)"
                :disabled="loading">
                <label class="fs-3 fw-bold bg-theme-1 text-light">{{
                    item.number
                }}</label>
                <img class="ms-2 ms-md-3" :src="item.picture" />
                <span class="fs-3 ms-2 ms-md-3">{{ item.fullname }}</span>
                <div class="d-inline float-end mt-2 me-2 mt-md-3 me-md-3 mark-box">
                  <i v-if="selectedCandidate == index" class="fa-solid fa-x"></i>
                </div>
              </a>
            </ul>
          </div>
        </div>
        <div class="bg-white rounded shadow-lg px-md-5 px-4 py-4 mb-4">
          <table>
            <tbody>
              <tr>
                <td class="vertical-top">
                  <div class="list-number me-2">5</div>
                </td>
                <td>
                  <h2 id="q5">
                    <span class="fw-bold">ปัญหาใดที่คุณอยากให้ผู้ว่าฯ กทม. คนใหม่ เร่งแก้ไขมากที่สุด
                      ?</span>
                    (ระบุ 1 ตัวเลือก)
                    <span v-if="warnings[4]" class="text-danger">
                      ( *กรุณาระบุตัวเลือก )</span>
                  </h2>
                  <div class="">
                    <div class="form-check fs-3">
                      <input class="form-check-input" type="checkbox" value="" id="checkReason1"
                        @change="selectReason(1)" :checked="reason == 1" :disabled="loading" />
                      <label class="form-check-label" for="checkReason1">
                        การเดินทาง
                      </label>
                    </div>
                    <div class="form-check fs-3">
                      <input class="form-check-input" type="checkbox" value="" id="checkReason2"
                        @change="selectReason(2)" :checked="reason == 2" :disabled="loading" />
                      <label class="form-check-label" for="checkReason2">
                        การศึกษา
                      </label>
                    </div>
                    <div class="form-check fs-3">
                      <input class="form-check-input" type="checkbox" value="" id="checkReason3"
                        @change="selectReason(3)" :checked="reason == 3" :disabled="loading" />
                      <label class="form-check-label" for="checkReason3">
                        ความปลอดภัยในชีวิตและทรัพย์สิน
                      </label>
                    </div>
                    <div class="form-check fs-3">
                      <input class="form-check-input" type="checkbox" value="" id="checkReason4"
                        @change="selectReason(4)" :checked="reason == 4" :disabled="loading" />
                      <label class="form-check-label" for="checkReason4">
                        ทุจริตคอร์รัปชัน
                      </label>
                    </div>
                    <div class="form-check fs-3">
                      <input class="form-check-input" type="checkbox" value="" id="checkReason5"
                        @change="selectReason(5)" :checked="reason == 5" :disabled="loading" />
                      <label class="form-check-label" for="checkReason5">
                        ปัญหาปากท้อง
                      </label>
                    </div>
                    <div class="form-check fs-3">
                      <input class="form-check-input" type="checkbox" value="" id="checkReason6"
                        @change="selectReason(6)" :checked="reason == 6" :disabled="loading" />
                      <label class="form-check-label" for="checkReason6">
                        ระบบบริการสุขภาพ
                      </label>
                    </div>
                    <div class="form-check fs-3">
                      <input class="form-check-input" type="checkbox" value="" id="checkReason7"
                        @change="selectReason(7)" :checked="reason == 7" :disabled="loading" />
                      <label class="form-check-label" for="checkReason7">
                        สิ่งแวดล้อม (ฝุ่น, สภาพอากาศ, ขยะ)
                      </label>
                    </div>
                    <div class="form-check fs-3">
                      <input class="form-check-input" type="checkbox" value="" id="checkReason8"
                        @change="selectReason(8)" :checked="reason == 8" :disabled="loading" />
                      <label class="form-check-label" for="checkReason8">
                        สิ่งอำนวยความสะดวกใน กทม.
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="mb-5 text-center">
          <button v-if="!success && !loading" class="btn btn-lg btn-submit text-light fs-1 fw-bold shadow-lg"
            v-on:click="submitVote">
            ส่งผลโหวต
          </button>
          <button v-if="!success && loading" class="btn btn-lg btn-submit text-light fs-1 fw-bold shadow-lg" disabled>
            <span class="spinner-grow spinner-grow-sm" style="width: 1.8rem; height: 1.8rem" role="status"
              aria-hidden="true"></span>
            กำลังประมวลผล
          </button>
        </div>
      </div>

      <div id="thanks" v-if="success || vote" class="mb-5">
        <div class="
          bg-white
          rounded
          shadow-lg
          px-md-5 px-4
          py-4
          pb-5
          my-5
          text-center
        ">
          <h1 v-if="success" class="text-tpbs-1 fw-bold">ขอบคุณที่ร่วมโหวตกับเรา</h1>
          <h1 v-if="vote" class="text-tpbs-1 fw-bold">คุณได้ใช้สิทธิ์โหวตไปแล้ว</h1>
          <h3 class="mt-4">
            ติดตามผล Thai PBS Poll และผลการนับคะแนนเลือกตั้งผู้ว่าฯ กทม. และ
            ส.ก.ได้ทางไทยพีบีเอส ช่องหมายเลข 3 และ
            <strong><a target="_blank"
                href="https://event.thaipbs.or.th/BKKElection65/">www.thaipbs.or.th/BKKElection65</a></strong>
          </h3>
          <hr />
          <h3 class="mt-4">หรือผ่านช่องทางโซเชียลมีเดีย</h3>
          <div>
            <a target="_blank" alt="Facebook" href="https://www.facebook.com/ThaiPBS"
              class="btn text-theme-1 fs-3 px-2">
              <i class="fa-brands fa-facebook"></i>
            </a>
            <a target="_blank" alt="Twitter" href="https://twitter.com/ThaiPBS" class="btn text-theme-1 fs-3 px-2">
              <i class="fa-brands fa-twitter"></i>
            </a>
            <a target="_blank" alt="Youtube" href="https://www.youtube.com/user/ThaiPBS"
              class="btn text-theme-1 fs-3 px-2">
              <i class="fa-brands fa-youtube"></i>
            </a>
            <a target="_blank" alt="LINE" href="http://www.thaipbs.or.th/AddLINE" class="btn text-theme-1 fs-3 px-2">
              <i class="fa-brands fa-line"></i>
            </a>
            <a target="_blank" alt="Instagram" href="https://www.instagram.com/ThaiPBS/"
              class="btn text-theme-1 fs-3 px-2">
              <i class="fa-brands fa-instagram"></i>
            </a>
            <a target="_blank" alt="TikTok" href="https://www.tiktok.com/@ThaiPBS" class="btn text-theme-1 fs-3 px-2">
              <i class="fa-brands fa-tiktok"></i>
            </a>
            <a target="_blank" alt="Blockdit" href="https://www.blockdit.com/ThaiPBS"
              class="btn text-theme-1 fs-3 px-2">
              <img src="imgs/blockdit.svg" style="vertical-align: baseline; width: 24px; height: 24px" />
            </a>
          </div>
        </div>
        <br /><br /><br /><br /><br /><br /><br /><br />
      </div>
    </div>
  </div>
</template>

<script>
import model from "../api/model";
import firebase from "../api/firebase";
import liff from "../api/liff";

export default {
  name: "HomeComp",
  props: {
    msg: String,
  },
  data: function () {
    return {
      isLoggedIn: false,
      user: null,
      vote: null,
      districts: model.districts,
      candidates: [],
      selectedCandidate: null,
      gender: null,
      reason: null,
      age: null,
      selectedDistrict: null,
      loading: false,
      success: false,
      warnings: [false, false, false, false, false],
      timeout: false
    };
  },
  created: function () {

    const d = new Date("2022-05-22 12:00:00")
    const now = new Date()
    if (now.getTime() > d.getTime()) {
      this.timeout = true
    }

    this.isLoggedIn = liff.isLoggedIn();
    if (this.isLoggedIn) {
      liff
        .getUser()
        .then((val) => {
          this.user = val;
          console.log(val);

          firebase
            .getVotesByUser(this.user.uid)
            .then((vals) => {
              if (vals.length > 0) this.vote = vals[0];
            })
            .catch((err) => {
              console.log(err);
            });

          firebase
            .getAllCandidates()
            .then((vals) => {
              this.candidates = vals;
              console.log(vals);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  },
  methods: {
    switchCandidate: function (index) {
      this.selectedCandidate = index;
    },
    toggleCandidate: function (index) {
      if (index == this.selectedCandidate) {
        return "item-active";
      } else {
        return "";
      }
    },
    selectGender: function (gender) {
      if (gender == this.gender) {
        this.gender = null;
      } else {
        this.gender = gender;
      }
    },
    selectReason: function (reason) {
      if (reason == this.reason) {
        this.reason = null;
      } else {
        this.reason = reason;
      }
    },
    submitVote: function () {
      if (this.revalidateForm()) {
        this.loading = true;
        var vote = model.Vote({
          uid: this.user.uid,
          candidateId: this.candidates[this.selectedCandidate].number,
          reason: this.reason,
          gender: this.gender,
          age: Number(this.age),
          district: this.selectedDistrict,
        });
        var uuser = this.user;

        firebase
          .commitVote(vote, uuser)
          .then((val) => {
            if (val) {
              this.loading = false;
              this.success = true;
              window.location.href = "#"
            } else {
              console.log("Already voted");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    revalidateForm: function () {
      var ok = true;

      this.warnings = [false, false, false, false, false]

      if (this.reason == null) {
        ok = false;
        this.warnings[4] = true
        window.location.href = "#q5";
      }

      if (this.selectedCandidate == null) {
        ok = false;
        this.warnings[3] = true
        window.location.href = "#q4";
      }

      if (this.selectedDistrict == null) {
        ok = false;
        this.warnings[2] = true
        window.location.href = "#q3";
      }

      if (this.age == null || this.age < 1) {
        ok = false;
        this.warnings[1] = true
        window.location.href = "#q2";
      }

      if (this.gender == null) {
        ok = false;
        this.warnings[0] = true
        window.location.href = "#q1";
      }

      return ok;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
